export default "https://cdn-static.gokick.com/assets/89c12df47656b56f32e50d5631dab02a560652ab/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";